/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
    UserToJSONTyped,
} from './User';

/**
 * 
 * @export
 * @interface Member
 */
export interface Member {
    /**
     * 
     * @type {string}
     * @memberof Member
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof Member
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Member
     */
    updatedAt: Date;
    /**
     * 
     * @type {User}
     * @memberof Member
     */
    user: User;
    /**
     * 
     * @type {string}
     * @memberof Member
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof Member
     */
    role: MemberRoleEnum;
}


/**
 * @export
 */
export const MemberRoleEnum = {
    Member: 'member',
    Admin: 'admin',
    Owner: 'owner'
} as const;
export type MemberRoleEnum = typeof MemberRoleEnum[keyof typeof MemberRoleEnum];


/**
 * Check if a given object implements the Member interface.
 */
export function instanceOfMember(value: object): value is Member {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('user' in value) || value['user'] === undefined) return false;
    if (!('organizationId' in value) || value['organizationId'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    return true;
}

export function MemberFromJSON(json: any): Member {
    return MemberFromJSONTyped(json, false);
}

export function MemberFromJSONTyped(json: any, ignoreDiscriminator: boolean): Member {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'user': UserFromJSON(json['user']),
        'organizationId': json['organizationId'],
        'role': json['role'],
    };
}

export function MemberToJSON(json: any): Member {
    return MemberToJSONTyped(json, false);
}

export function MemberToJSONTyped(value?: Member | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'user': UserToJSON(value['user']),
        'organizationId': value['organizationId'],
        'role': value['role'],
    };
}

